export default __webpack_public_path__ + "static/jaques-7069bee185d6c1dc7c20bfe34956ad41.jpeg";